<template>
  <nav class="nav">
    <div class="navbar-inner">
      <div class="navbar-item">
        <router-link :to="{ name: 'home', query: (site ? { id_site: site.id_site } : {}) }"
                     class="navbar-text logo-text">Opoint</router-link>
        <span class="navbar-text">
          <span>Hint Manager</span>
        </span>
      </div>
      <div class="navbar-item links">
        <span v-if="site" class="site-info">
          {{ site.sitename }} ({{ site.id_site }}) -
          <span class="ocl-version">{{ site.ocl_version === 4 ? 'PyOCL' : 'OCL' }}</span>
        </span>
      </div>
      <div class="navbar-item auth">
        <span class="navbar-text">
          Logged in as: <strong>{{ username }}</strong>
        </span>
        <button type="button" class="navbar-button" @click="logOut">Log out</button>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Navbar',
  methods: {
    logOut() {
      this.$store.commit('auth/logOut')
      this.$router.push({ name: 'login' })
    }
  },
  props: {
    urlDev: {
      type: String
    },
  },
  computed: {
    ...mapState({
      id_site: state => state.id_site,
      id_link: state => state.id_link,
    }),
    ...mapState('site', {
      site: state => state.data,
    }),
    username() {
      if (this.$store.getters['auth/isLoggedIn'] && 'username' in this.$store.state.auth.auth.state.user) {
        return this.$store.state.auth.auth.state.user.username
      }
      return 'Unknown'
    },
    navbarText() {
      return this.$store.state.navbarText
    },
  }
}
</script>

<style scoped lang="sass">
@use '../styles/variables' as v

.navbar-button
  padding: 0
  margin: 0
  background: none
  border: none
  font-family: inherit
  font-size: inherit
  color: v.$white

  &:hover
    text-decoration: underline

  &:focus
    outline: none

nav.nav
  background-color: v.$ui-background
  border-bottom: v.$ui-border
  z-index: 1030
  height: v.$navbar-height
  position: fixed
  top: 0
  left: 0
  width: 100%
  padding: 0
  font-size: v.$font-size-small

  .navbar-inner
    padding: 0 15px
    display: grid
    //grid-template-columns: auto 1fr auto
    grid-template-columns: 1fr auto 1fr
    width: 100%

  .navbar-item
    display: flex
    align-items: center
    padding: 0

    &.links ul
      display: flex
      height: 100%
      width: 100%
      align-items: center
      justify-content: center

      li
        margin: 0 6px

        button
          color: v.$gray

          &.router-link-exact-active, &.active
            color: v.$white

    &.auth
      justify-self: right
      text-align: right

      .username
        margin: 0 10px

      .logout-button
        float: right

  .navbar-text
    font-weight: 300
    color: v.$white
    margin-right: 8px
    padding: 0

    a
      color: v.$white
      text-decoration: underline

    &.logo-text
      font-family: 'Roboto Slab', serif
      color: v.$dark-white
      font-weight: bold
      text-decoration: none

    &:hover
      text-decoration: none
</style>
